import { FILTER_STATUS_SOURCING_PROJECTS } from './constants'

const initialState = {
  status: 0,
  event: null,
}
export const getStatusSourcingProjects = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_STATUS_SOURCING_PROJECTS:
      return {
        ...state,
        status: action.status,
        event: action.event,
      }
    default:
      return state
  }
}
